import { Row, Col, Skeleton } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';

import { loadingStatus } from 'helpers/fetcher';
import { fetchWishlist } from 'store/slices/customerSlice';
import AccountMenu from 'components/menu/AccountMenu';
import AccountLogoutButton from 'components/menu/AccountMenu/AccountLogoutButton';
import CartQtyButtonGroup from 'components/cart/CartQtyButtonGroup';
import WishlistButton from 'components/cart/WishlistButton';
import useSmartNavigate from 'hooks/useSmartNavigate';
import { formatWeightWithUnit } from 'helpers/formatter';
import { getStock } from 'helpers/product';
import Icon from 'components/Icon';
import ProductPriceRow from 'components/product/ProductPriceRow';
import { useTranslation } from 'react-i18next';

const Wishlist = () => {
	const { t } = useTranslation();
  const dispatch = useDispatch();
	const navigate = useNavigate();
	const { navigate: smartNavigate } = useSmartNavigate();
	const { data, status } = useSelector(state => state.customer.wishlist);

  useEffect(() => {
    dispatch(fetchWishlist());
  }, [dispatch]);

  return (
		<div className="region account-section">
			{/* Breadcrumb */}
			<div className="contact-breadcrumb" style={{ marginTop: '64px' }}>
				<a
					href="/"
					onClick={e => {
						e.preventDefault();
						navigate('/');
					}}
					className="breadcrumb-link"
				>
					Главная
				</a>
				<span className="breadcrumb-separator breadcrumb-separator-active"></span>
				<span className="breadcrumb-current">Личный кабинет</span>
			</div>

			{/* Title */}
			<h1 className="account-title">ИЗБРАННЫЕ</h1>

			{/* Layout */}
			<div className="account-layout">
				{/* Sidebar */}
				<div className="account-sidebar">
					<AccountMenu />
				</div>

				{/* Content */}
				<div className="account-content">
					{status === loadingStatus.SUCCEEDED ? (
						<Row gutter={[32, 32]} className="popular-products-list">
							{(data?.products || []).map((item, index) => {
								const stock = getStock(item);
								const handleGotoItem = () => {
									if (item.product_id) {
										const slug = item.slug || item.name?.toLowerCase().replace(/\s+/g, '-') || 'product';
										smartNavigate(`/product/${item.product_id}/${slug}`);
									}
								};

								return (
									<Col
										xs={12}
										sm={12}
										md={8}
										lg={8}
										key={item.product_id || index}
									>
										<div
											className="popular-product-card"
											onClick={handleGotoItem}
											style={{ cursor: 'pointer' }}
										>
											<div className="popular-product-image-wrapper">
												<img
													src={item.thumb}
													alt={item.name}
													className="popular-product-image"
												/>
												{item.rating && (
													<div className="popular-product-rating">
														<Icon name="icon-star" className="popular-product-rating-icon" ariaLabel={t('home.rating')} />
														<span className="popular-product-rating-value">
															{item.rating}
														</span>
													</div>
												)}
											</div>
											<div
												className="popular-product-favorite"
												onClick={e => e.stopPropagation()}
											>
												<WishlistButton
													product_id={item.product_id}
													active={true}
													actionAfterDelete={() => dispatch(fetchWishlist())}
												/>
											</div>
											<h3 className="popular-product-title">
												{item.name}, {formatWeightWithUnit(item.weight)}
											</h3>
											<ProductPriceRow item={item} />
											<div onClick={e => e.stopPropagation()}>
												<CartQtyButtonGroup item={item} block size="large" />
											</div>
											<div
												className={`popular-product-stock ${
													stock.stock === 0
														? 'popular-product-stock-unavailable'
														: ''
												}`}
											>
												{stock.stock === 0
													? t('stock.outOfStock')
													: stock.stock === 999
													? t('stock.inStockMany')
													: t('stock.inStockCount', { count: stock.stock })}
											</div>
										</div>
									</Col>
								);
							})}
						</Row>
					) : (
						<Row gutter={[32, 32]} className="popular-products-list">
							{Array(4)
								.fill({})
								.map((_, index) => (
									<Col xs={12} sm={12} md={8} lg={8} key={index}>
										<Skeleton active avatar paragraph={{ rows: 4 }} />
									</Col>
								))}
						</Row>
					)}
				</div>
			</div>

			{/* Кнопка выхода для мобильных */}
			<AccountLogoutButton />
    </div>
  );
};

export default Wishlist;
